<p-table [scrollable]="true" [size]="'small'" [value]="callStatistics()" scrollHeight="flex" stripedRows>
  <ng-template #header>
    <tr>
      <th pSortableColumn="date" style="width: 140px">{{ 'call-statistic.date' | translate }}
        <p-sortIcon field="date"/>
      </th>
      <th pSortableColumn="callsTotal">{{ 'call-statistic.calls-total' | translate }}
        <p-sortIcon field="callsTotal"/>
      </th>
      <th pSortableColumn="callsAnswered">{{ 'call-statistic.calls-answered' | translate }}
        <p-sortIcon field="callsAnswered"/>
      </th>
      <th pSortableColumn="callsLost">{{ 'call-statistic.calls-lost' | translate }}
        <p-sortIcon field="callsLost"/>
      </th>
      <th pSortableColumn="totalCallDurationSeconds">{{ 'call-statistic.total-call-duration' | translate }}
        <p-sortIcon field="totalCallDurationSeconds"/>
      </th>
      <th pSortableColumn="totalWaitingDurationSeconds">{{ 'call-statistic.total-waiting-duration' | translate }}
        <p-sortIcon field="totalWaitingDurationSeconds"/>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-callStatistic>
    <tr>
      <td>{{ callStatistic.date | date: 'dd/MM/yyyy' }}</td>
      <td class="tabular-nums">{{ callStatistic.callsTotal }}</td>
      <td class="tabular-nums">{{ callStatistic.callsAnswered }}</td>
      <td class="tabular-nums">{{ callStatistic.callsLost }}</td>
      <td class="tabular-nums">{{ callStatistic.totalCallDurationSeconds | callDuration }}</td>
      <td class="tabular-nums">{{ callStatistic.totalWaitingDurationSeconds | callDuration }}</td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td class="text-center" colspan="6">{{ 'app.no-data' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
